/* MTT Lieferdatum. EINE Rechnung für Produktseite (assets/mtt-produkt.js) und Warenkorb (snippets/mtt-schublade).
   Stand 25.10.2026, Johns Vorgaben:
   - Lagerware: Fenster „Lieferung zwischen … und …“ = Versandtag + min bis Versandtag + max Zustelltage (Standard 1 bis 2, aus dem
     Lieferregeln-JSON des Themes; Eigenfertigung eigenMin/eigenMax, Länder-Werte aus laender). Nie „bis spätestens“.
   - Versandtage: Mo bis Fr ohne Feiertage. Versandtag = heute, wenn heute Versandtag und in Berlin vor dem Versandschluss (12:00),
     sonst der nächste Versandtag.
   - Zustelltage: Mo bis Sa ohne Feiertage (DHL stellt samstags zu).
   - Feiertage = bundesweit + Hessen (Fronleichnam, Packstar Friedberg), jedes Jahr selbst berechnet (Ostern nach Gauß), dazu die Liste
     aus den Lieferregeln. Die Felder versandtage, zustelltage und bearbeitung_tage der Lieferregeln gelten hier nicht mehr.
   - Zuschläge in Versandtagen auf den Versandtag: extra (Feld mtt.liefer_extra_tage, z. B. Überbrückung Packstar) und druck
     (Lieferregeln druckTage je SKU-Anfang, z. B. Thermo-Becher MTT-SMAR- +5, weil John bedruckt).
   - Vorbestellung: Datum steht fertig am Artikel (mtt.liefer_bis); darauf kommt nur der Druck-Zuschlag (vorbestellBis).
   Rechnung im Browser, weil sich das Fenster mit der Uhrzeit verschiebt und Seiten gecacht sein können.
   Doku: MTT/lieferzeit-neu/shopify-daten/README.md, MTT/shop-ueberarbeitung/lieferzeile-bewertungen-2026-10-25/BERICHT.md */
(function () {
  if (window.MTTLiefer) return;
  var KURZ = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function mittag(isoDatum) { return new Date(isoDatum + 'T12:00:00'); }
  function land(r, code, tiefe) {
    var l = (r.laender || {})[code];
    if (l && l.same_as && (tiefe || 0) < 5) return land(r, l.same_as, (tiefe || 0) + 1);
    if (l) return l;
    return code === 'DE' ? null : (r.laender || {})._default_foreign || null;
  }
  // Datum und Stunde in Berlin, unabhängig von der Zeitzone des Geräts
  function berlin(jetzt) {
    var t = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
      .formatToParts(jetzt).forEach(function (p) { t[p.type] = p.value; });
    return { datum: t.year + '-' + t.month + '-' + t.day, stunde: Number(t.hour) % 24 };
  }
  // Ostersonntag (Gauß/Meeus, gregorianisch)
  function ostern(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return new Date(j, Math.floor(n / 31) - 1, (n % 31) + 1, 12);
  }
  var FT = {};
  // Bundesweit: Neujahr, Karfreitag, Ostermontag, 1. Mai, Himmelfahrt, Pfingstmontag, 3. Oktober, 1./2. Weihnachtstag; Hessen: Fronleichnam
  function feiertageJahr(j) {
    if (FT[j]) return FT[j];
    var o = ostern(j), plus = function (n) { var d = new Date(o); d.setDate(d.getDate() + n); return iso(d); };
    FT[j] = [j + '-01-01', plus(-2), plus(1), j + '-05-01', plus(39), plus(50), plus(60), j + '-10-03', j + '-12-25', j + '-12-26'];
    return FT[j];
  }
  function istFeiertag(r, d) { var s = iso(d); return feiertageJahr(d.getFullYear()).indexOf(s) > -1 || (r.feiertage || []).indexOf(s) > -1; }
  function istWerktag(r, d) { var t = d.getDay(); return t >= 1 && t <= 5 && !istFeiertag(r, d); }        // Versandtag
  function istZustelltag(r, d) { var t = d.getDay(); return t >= 1 && t <= 6 && !istFeiertag(r, d); }     // Zustelltag (mit Samstag)
  function naechsterWerktag(r, d) { do { d.setDate(d.getDate() + 1); } while (!istWerktag(r, d)); return d; }
  function naechsterZustelltag(r, d) { do { d.setDate(d.getDate() + 1); } while (!istZustelltag(r, d)); return d; }
  function plusWerktage(r, isoDatum, n) { var d = mittag(isoDatum); while (n > 0) { naechsterWerktag(r, d); n--; } return iso(d); }
  function plusZustelltage(r, isoDatum, n) { var d = mittag(isoDatum); while (n > 0) { naechsterZustelltag(r, d); n--; } return iso(d); }
  // Druck-Zuschlag einer Variante aus r.druckTage { "SKU-Anfang": Werktage }
  function druckTage(r, sku) {
    var m = 0, t = r.druckTage || {}; sku = String(sku || '');
    for (var k in t) if (Object.prototype.hasOwnProperty.call(t, k) && k && sku.indexOf(k) === 0) m = Math.max(m, Number(t[k]) || 0);
    return m;
  }
  // r: Regeln (JSON aus dem Theme), code: Land (z. B. DE), eigen: Eigenfertigung, jetzt: Date (Test), extra/druck: Zuschläge in Werktagen
  function fenster(r, code, eigen, jetzt, extra, druck) {
    jetzt = jetzt || new Date();
    var min = r.min, max = r.max, l = land(r, code || 'DE');
    if (l && (code || 'DE') !== 'DE') { if (l.min_delivery_days != null) min = l.min_delivery_days; if (l.max_delivery_days != null) max = l.max_delivery_days; }  /* 25.10.2026: DE fest 1 bis 2 Zustelltage (Johns Vorgabe), Länder-Eintrag nur fürs Ausland */
    if (eigen && r.eigenMin != null && r.eigenMax != null) { min = r.eigenMin; max = r.eigenMax; }
    var b = berlin(jetzt), schluss = parseInt(String(r.versandschluss || '12:00').split(':')[0], 10), v;
    if (r.abwesendVon && r.abwesendBis && b.datum >= r.abwesendVon && b.datum <= r.abwesendBis) {
      v = naechsterWerktag(r, mittag(r.abwesendBis));           // erster Werktag nach der Abwesenheit
    } else {
      v = mittag(b.datum);
      if (!(istWerktag(r, v) && b.stunde < schluss)) naechsterWerktag(r, v);
    }
    var z = (extra > 0 ? extra : 0) + (druck > 0 ? druck : 0);
    while (z-- > 0) naechsterWerktag(r, v);
    var versand = iso(v);
    return { versand: versand, von: plusZustelltage(r, versand, min), bis: plusZustelltage(r, versand, max) };
  }
  // Vorbestellung: Spätestens-Datum vom Artikel plus Druck-Zuschlag
  function vorbestellBis(r, bisIso, sku) { var d = druckTage(r, sku); return d > 0 ? plusWerktage(r, bisIso, d) : bisIso; }
  function kurz(isoDatum) { var d = mittag(isoDatum); return KURZ[d.getDay()] + ', ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
  function plusTage(n) { var d = new Date(); d.setDate(d.getDate() + n); return iso(d); }
  window.MTTLiefer = { fenster: fenster, kurz: kurz, plusTage: plusTage, iso: iso, plusWerktage: plusWerktage, druckTage: druckTage,
    vorbestellBis: vorbestellBis, istWerktag: istWerktag, istZustelltag: istZustelltag, feiertageJahr: feiertageJahr };
})();
